/**
 * 순매출 상위 배너의 제작 이미지.
 * 순위는 API가 정하고, 여기에는 상품 코드별 그림과 제작 당시 대표 이미지만 둔다.
 * 대표 이미지가 바뀌면 이 그림은 오래된 것으로 보고 상품 썸네일을 대신 보여 준다.
 */

export const MALL_TOP_SALES_BANNER_DIR = 'vuejs_jangi/public/images/mall-banners/top-sales'

export interface MallTopSalesBannerAsset {
  code: string
  image: string
  sourceThumbnail: string
  direction: string
  prompt: string
}

export interface TopSalesBannerBrief {
  rank: number
  code: string
  name: string
  category: string
  summary: string
  description: string
  price: number
  unit: string
  origin: string
  maker: string
  thumbnail: string
  specs: { label: string; value: string }[]
}

export const MALL_TOP_SALES_BANNERS: Record<string, MallTopSalesBannerAsset> = {
  MP000017: {
    code: 'MP000017',
    image: '/images/mall-banners/top-sales/mp000017-wild-ginseng.jpg',
    sourceThumbnail: '/api/mall/images/1786944015435-fd7538586a33.jpg',
    direction: '딥그린·금박, 세로로 쌓인 선물 상자와 진액 파우치, 산삼 뿌리',
    prompt:
      '9:16 세로 웹배너. 짙은 에메랄드 배경과 따뜻한 금빛. 큰 초록 선물 상자는 아래에 두고, 초록 파우치와 산삼 뿌리·붉은 열매를 위로 올린다. 글자·가격·뱃지·워터마크는 넣지 않는다.',
  },
  MP000015: {
    code: 'MP000015',
    image: '/images/mall-banners/top-sales/mp000015-honey-sticks.jpg',
    sourceThumbnail: '/api/mall/images/1788746282812-4b96c319ed8c.png',
    direction: '코발트 선물백, 적갈·남색·차콜 꿀스틱 상자, 매화와 돌 쟁반',
    prompt:
      '9:16 세로 웹배너. 세이지 벽과 부드러운 낮 빛. 코발트 선물백을 높이 두고, 적갈·남색·차콜 상자 셋을 가운데, 꿀스틱을 돌 쟁반에 낮게 둔다. 흰 매화를 곁들인다. 글자·가격·뱃지·워터마크는 넣지 않는다.',
  },
  MP000022: {
    code: 'MP000022',
    image: '/images/mall-banners/top-sales/mp000022-sesame-set.jpg',
    sourceThumbnail: '/api/mall/images/1786948183545-3f59a74143f4.jpg',
    direction: '웜 베이지 스튜디오, 참기름 병·참깨 병·크라프트 상자',
    prompt:
      '9:16 세로 웹배너. 크림색 벽과 밝은 나무 테이블, 아침 빛. 금빛 참기름 병, 금뚜껑 참깨 병, 검은 손잡이의 크라프트 상자를 여백 있게 세운다. 글자·가격·뱃지·워터마크는 넣지 않는다.',
  },
  MP000035: {
    code: 'MP000035',
    image: '/images/mall-banners/top-sales/mp000035-red-ginseng.jpg',
    sourceThumbnail: '/api/mall/images/1786975267278-79b6e000cf71.jpg',
    direction: '적색·한지 베이지, 금뚜껑 항아리와 붉은 스틱',
    prompt:
      '9:16 세로 웹배너. 따뜻한 한지색 바닥과 붉은 빛. 금뚜껑 어두운 유리 항아리 둘, 붉은 선물 상자, 붉은 스틱 둘을 의식처럼 배치한다. 글자·가격·뱃지·워터마크는 넣지 않는다.',
  },
  MP000028: {
    code: 'MP000028',
    image: '/images/mall-banners/top-sales/mp000028-seaweed-coast.jpg',
    sourceThumbnail: '/api/mall/images/1786971290128-285e764380a7.jpg',
    direction: '해안 블루, 남색 가방과 금색·초록 김 캔',
    prompt:
      '9:16 세로 웹배너. 바다 빛과 베이지 바닥. 남색 로프 손잡이 가방 앞에 열린 남색 상자를 두고, 그 안에 금색 캔과 초록 캔을 나란히 둔다. 글자·가격·뱃지·워터마크는 넣지 않는다.',
  },
  MP000023: {
    code: 'MP000023',
    image: '/images/mall-banners/top-sales/mp000023-seaweed-ink.jpg',
    sourceThumbnail: '/api/mall/images/1786948760112-ce2640aea38f.jpg',
    direction: '흑백 수묵, 흰 캔 세 개와 손잡이 상자',
    prompt:
      '9:16 세로 웹배너. 하이키 흰 배경과 옅은 수묵 산. 검은 손잡이 흰 상자 앞에 김이 담긴 흰 원통 캔 세 개를 나란히 둔다. 글자·가격·뱃지·워터마크는 넣지 않는다.',
  },
  MP000029: {
    code: 'MP000029',
    image: '/images/mall-banners/top-sales/mp000029-salt-prism.jpg',
    sourceThumbnail: '/api/mall/images/1786971633184-8716cfc6297a.jpg',
    direction: '네이비 상자 안의 다섯 색 소금 병과 굵은 소금',
    prompt:
      '9:16 세로 웹배너. 짙은 남색 배경. 열린 남색 상자에 허브·보라·흰·갈·후추색 소금 병 다섯 개를 세로로 넣고, 오른쪽에 굵은 소금을 흩는다. 글자·가격·뱃지·워터마크는 넣지 않는다.',
  },
  MP000033: {
    code: 'MP000033',
    image: '/images/mall-banners/top-sales/mp000033-albumin.jpg',
    sourceThumbnail: '/api/mall/images/1786974125877-e961bd3ee545.jpg',
    direction: '블랙·라임 테크, 흰 보틀 세 칸과 앞 보틀',
    prompt:
      '9:16 세로 웹배너. 흰 배경과 또렷한 그림자. 라임 테두리의 검은 상자에 흰 보틀 세 개를 넣고, 앞에 보틀 하나를 세운다. 사람·글자·가격·뱃지·워터마크는 넣지 않는다.',
  },
  MP000032: {
    code: 'MP000032',
    image: '/images/mall-banners/top-sales/mp000032-seaweed-gold.jpg',
    sourceThumbnail: '/api/mall/images/1786973770558-7d5c57e6a6db.jpg',
    direction: '골드 파우치 계단과 푸른 바다 손잡이 상자',
    prompt:
      '9:16 세로 웹배너. 따뜻한 금색 빛과 흰 바닥. 작은 베이지 파우치를 계단처럼 쌓고, 앞에 금색 김 파우치 셋을 두며, 파란 손잡이 상자를 옆에 세운다. 글자·가격·뱃지·워터마크는 넣지 않는다.',
  },
  MP000030: {
    code: 'MP000030',
    image: '/images/mall-banners/top-sales/mp000030-pantry-set.jpg',
    sourceThumbnail: '/api/mall/images/1786972477247-18ad39818595.jpg',
    direction: '모던 팬트리, 남색 상자 안의 소스 병·크림 카톤과 소금 그릇',
    prompt:
      '9:16 세로 웹배너. 차가운 남색 배경. 열린 남색 상자에 크림색 카톤과 어두운 유리 소스 병을 넣고, 옆에 소금 그릇과 흩어진 굵은 소금을 둔다. 손·글자·가격·뱃지·워터마크는 넣지 않는다.',
  },
}

export function bannerAssetFor(code: string) {
  return MALL_TOP_SALES_BANNERS[code] || null
}

export function bannerNeedsRefresh(code: string, thumbnail: string) {
  const asset = bannerAssetFor(code)
  return !asset || asset.sourceThumbnail !== thumbnail
}

export function resolveTopSalesBanner(code: string, thumbnail: string) {
  const asset = bannerAssetFor(code)
  if (!asset || asset.sourceThumbnail !== thumbnail) return thumbnail
  return asset.image
}

function won(value: number) {
  return `${Number(value || 0).toLocaleString('ko-KR')}원`
}

function bannerState(brief: TopSalesBannerBrief) {
  const asset = bannerAssetFor(brief.code)
  if (!asset) return '배너 없음. 새로 만든다.'
  if (asset.sourceThumbnail !== brief.thumbnail) {
    return `대표 이미지가 바뀌어 배너가 오래됐다. 제작 기준 ${asset.sourceThumbnail}, 현재 ${brief.thumbnail}. 새로 만든다.`
  }
  return `현재 배너를 유지한다. ${asset.image} / ${asset.direction}`
}

/** Cursor에 붙여 넣으면 순위·이미지 변경분만큼 배너를 다시 만들게 하는 지시문. */
export function buildTopSalesBannerPrompt(products: TopSalesBannerBrief[]) {
  const ranked = [...products].sort((a, b) => a.rank - b.rank)
  const catalog = ranked
    .map((product) => {
      const specs = product.specs.length
        ? product.specs.map((spec) => `${spec.label}: ${spec.value}`).join(', ')
        : '없음'
      return [
        `${product.rank}. ${product.name} (${product.code})`,
        `분류: ${product.category || '-'}`,
        `가격: ${won(product.price)}`,
        `요약: ${product.summary || '-'}`,
        `설명: ${product.description || '-'}`,
        `단위: ${product.unit || '-'} / 원산지: ${product.origin || '-'} / 제조: ${product.maker || '-'}`,
        `스펙: ${specs}`,
        `현재 대표 이미지: ${product.thumbnail || '없음'}`,
        `배너 상태: ${bannerState(product)}`,
      ].join('\n')
    })
    .join('\n\n')

  const kept = Object.values(MALL_TOP_SALES_BANNERS)
    .map((asset) => `- ${asset.code}: ${asset.direction}`)
    .join('\n')

  return [
    '함우리몰 포털 좌측 웹배너를 현재 순매출 Top10에 맞게 갱신해 줘.',
    '',
    '순위는 GET /api/mall/products/top-sales 가 정한다. 전체 기간 구매확정 상품금액에서 배송완료·구매확정 후 반품 상품금액을 뺀 값이며, 배송비는 제외한다. 판매중이고 테스트 상품이 아니며 대표 이미지가 있는 상품만 나온다. 컴포넌트에 상품 순서 배열을 하드코딩하지 마.',
    '',
    '아래 목록에서 배너가 없거나 대표 이미지가 제작 기준과 다른 상품만 9:16 이미지를 새로 만든다. 상태가 맞는 상품은 기존 파일을 유지한다.',
    `새 파일은 ${MALL_TOP_SALES_BANNER_DIR} 에 저장하고, vuejs_jangi/src/constants/mallTopSalesBanners.ts 의 해당 상품 image, sourceThumbnail, direction, prompt 를 갱신한다. sourceThumbnail 은 그 상품의 현재 대표 이미지 URL과 같아야 한다.`,
    '10개 배너는 구도·색·분위기가 모두 달라야 한다. 글자, 가격, 할인 뱃지, 워터마크는 이미지에 넣지 않는다. 상품명과 가격은 화면이 표시한다.',
    '상품 포장·병·상자는 AI로 다시 그리지 마. 현재 대표 이미지 파일에서 상품만 누끼 따고, 그 상품에 어울리는 9:16 배경만 새로 만든 뒤 합성한다. 대표 이미지가 없는 상품은 배너를 만들지 마.',
    '실행 중인 프론트·백엔드 서버는 다시 시작하지 마.',
    '',
    '이미 있는 디자인 방향:',
    kept,
    '',
    '현재 Top10:',
    catalog,
  ].join('\n')
}
